// @flow

import React, { Fragment } from 'react';
import loadImage from 'blueimp-load-image';
import { useDispatch } from 'react-redux';
import { showCrop } from './actions';

function FileInput() {
  const dispatch = useDispatch();
  const fileSelect = React.createRef();

  const onFileChange = async e => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      loadImage.parseMetaData(
        file,
        function(data) {
          loadImage(
            file,
            function(canvas) {
              const base64data = canvas.toDataURL('image/jpeg');
              dispatch(showCrop(base64data));
            }, {
              canvas: true,
              maxWidth: 2048,
            }
          );
        }
      );
    }
  }

  return (
    <Fragment>
      <input type="file"
        ref={fileSelect}
        value=''
        style={{display: 'none'}}
        onChange={onFileChange}
        id="crop_select_image"
        data-action="input->birthday-children-form#onchangeField"
      />
      <button onClick={(e) => { e.preventDefault(); fileSelect.current.click(); } } className="btn without-margin">Kies een foto</button>
    </Fragment>
  )
}

export default FileInput;
